/**
 * Leve camada de analytics. Dispara eventos para Google Analytics (gtag)
 * e Meta Pixel (fbq) quando os scripts estão disponíveis na página.
 * Todos os disparos são protegidos por try/catch — nunca derrubam a UI.
 *
 * Para ativar:
 *   1. Adicione o snippet do GA4 e/ou Meta Pixel em /app/frontend/public/index.html
 *      (veja comentário "ANALYTICS — opt-in" no <head>).
 *   2. Nada mais precisa ser alterado no código da aplicação.
 *
 * Eventos suportados:
 *   - donate_click  { source }                 -> clique em qualquer CTA de doação
 *   - pix_copy      { tipo_chave: cnpj|email|aleatoria|brcode }  -> cópia de chave Pix
 */

function safe(fn) {
  try {
    fn();
  } catch (_) {
    /* no-op */
  }
}

function hasGtag() {
  return typeof window !== "undefined" && typeof window.gtag === "function";
}

function hasFbq() {
  return typeof window !== "undefined" && typeof window.fbq === "function";
}

export const analytics = {
  donateClick(source = "unknown") {
    safe(() => {
      if (hasGtag()) {
        window.gtag("event", "donate_click", {
          event_category: "donation",
          event_label: source,
          source,
        });
      }
    });
    safe(() => {
      if (hasFbq()) {
        window.fbq("track", "Donate", { source });
      }
    });
  },
  pixCopy(tipoChave) {
    const tipo = tipoChave || "desconhecido";
    safe(() => {
      if (hasGtag()) {
        window.gtag("event", "pix_copy", {
          event_category: "donation",
          event_label: tipo,
          tipo_chave: tipo,
        });
      }
    });
    safe(() => {
      if (hasFbq()) {
        window.fbq("trackCustom", "PixCopy", { tipo_chave: tipo });
      }
    });
  },
};

export default analytics;
